import { getProduto } from 'config/produto-env';
import { useAuth } from 'context/AuthContext';
import { useActivePhases } from 'hooks/useControlDate';
import { deveMostrarMenuPreInscricao } from 'utils/destino-inicial';

/** O item "Pré-inscrição" do menu aparece para a pessoa logada? */
export function useMostrarMenuPreInscricao(): boolean {
  const { user } = useAuth();
  const fases = useActivePhases();
  return deveMostrarMenuPreInscricao(user?.pessoa, fases, getProduto());
}
